import { useEffect } from "react"
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { COMMAND_PRIORITY_HIGH, KEY_ENTER_COMMAND } from "lexical"

interface OnEnterPluginProps {
  onEnter?: () => void
  shouldIgnore?: () => boolean
}

export default function OnEnterPlugin({ onEnter, shouldIgnore }: OnEnterPluginProps) {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    if (!onEnter) return

    const removeListener = editor.registerCommand(
      KEY_ENTER_COMMAND,
      (event: KeyboardEvent | null) => {
        if (event && !event.shiftKey) {
          if (event.isComposing || editor.isComposing()) {
            return false
          }
          if (typeof shouldIgnore === "function" && shouldIgnore()) {
            return false
          }
          event.preventDefault()
          onEnter()
          return true // This prevents Lexical from handling the enter key
        }
        return false
      },
      COMMAND_PRIORITY_HIGH
    )

    return removeListener
  }, [editor, onEnter, shouldIgnore])

  return null
}
